require('./style.scss');

export const showBackgroundAudioModal = (translate, send) => {
    const container = document.createElement('div');
    container.classList.add('background-audio-container');
    const body = document.createElement('div');
    body.classList.add('background-audio');
    const span = document.createElement('span');
    span.innerText = translate('DO_YOU_WANT_PLAY_BACKGROUND_AUDIO')
    span.classList.add('background-audio-label');
    const buttonOk = document.createElement('button');
    buttonOk.classList.add('button-ok-submit');
    buttonOk.classList.add('button');
    buttonOk.value = translate('YES');
    buttonOk.innerHTML = translate('YES');
    buttonOk.onclick = (e) => {
        e.preventDefault();

        send(true);
    }

    const buttonNo = document.createElement('button');
    buttonNo.classList.add('button-no-submit');
    buttonNo.classList.add('button');
    buttonNo.value = translate('NO');
    buttonNo.onclick = (e) => {
        e.preventDefault();

        send(false);
    }
    buttonNo.innerHTML = translate('NO');

    const buttonBlock = document.createElement('div');
    buttonBlock.classList.add('button-block');
    buttonBlock.appendChild(buttonOk);
    buttonBlock.appendChild(buttonNo);

    body.appendChild(span);
    body.appendChild(buttonBlock);
    container.appendChild(body);

    return container;
}
